import { useTranslation } from 'react-i18next';
import { ActivationRequestFailedError, provisionSim } from './api/simActionsApi';
import { ConfirmActionDialog } from 'common/components/ConfigurableTable/Components/Actions/ConfirmActionDialog';
import { useMutation } from '@tanstack/react-query';
import { AuthError } from 'auth/utils';
import { useState } from 'react';
import {
  ActivationError,
  ActivationSnackbar,
} from 'common/components/Activation/ActivationSnackbar';
import {
  sendGoogleTagManagerAction,
  GoogleTagManagerActions,
} from 'src/common/utils/sendGoogleTagManagerAction';

type ActivationDialogProps = {
  open: boolean;
  onClose: () => void;
  data: any;
};

export const ActivationDialog = ({ data, open, onClose }: ActivationDialogProps) => {
  const { t } = useTranslation();

  const [activationError, setActivationError] = useState<ActivationError | null>(null);

  const { mutate } = useMutation({
    mutationKey: ['sim-provisisioning'],
    mutationFn: async () => {
      await provisionSim([data.connectionId], true);
    },
    retry: 0,
    onError: (error) => {
      if (error instanceof AuthError) {
        throw error;
      } else if (error instanceof ActivationRequestFailedError) {
        setActivationError({
          title: t('common.activationRequestFailed'),
          description: [
            t('common.anotherRequestStillInProgress'),
            t('simInventory.pleaseTryAgainLater'),
          ],
        });
      } else {
        setActivationError({ title: error.message, description: [] });
      }
      sendGoogleTagManagerAction(GoogleTagManagerActions.SingleSimProductActivationFailure);
    },
    onSuccess: () => {
      sendGoogleTagManagerAction(GoogleTagManagerActions.SingleSimProductActivationSuccess);
    },
  });

  return (
    <>
      <ConfirmActionDialog
        open={open}
        data={data}
        onClose={onClose}
        submit={async () => mutate()}
        message={`${t('simInventory.activationIccid')} ${data?.iccid}`}
        title={t('simInventory.activation')}
      />
      <ActivationSnackbar error={activationError} setError={setActivationError} />
    </>
  );
};
